var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'three-dot-button',
    { 'three-dot-button--vertical': _vm.isVertical },
    { 'three-dot-button--active': _vm.active },
    { 'crm-style' : _vm.crmStyle } ],on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{style:(_vm.style)}),_vm._v(" "),_c('span',{style:(_vm.style)}),_vm._v(" "),_c('span',{style:(_vm.style)})])}
var staticRenderFns = []

export { render, staticRenderFns }